import * as yup from "yup";
import dayjs from "dayjs";

/* VALIDAZIONI DATE YUP - START */
export const yupReservationFromFunc = ({
                                           t,
                                           id,
                                           reservationFrom
                                       }: { t: Function, id: number | null, reservationFrom: string, }) => yup
    .date()
    .nullable()
    .required(t("translation:validation.fieldMandatory"))
    .typeError(t("pricing:validation.date"))
    // @ts-ignore
    .when("id", (yupId, schema, val) => {
        // CREAZIONE
        if (id === null) {
            return yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
                .typeError(t("pricing:validation.date"));
            // .min(new Date(), t("pricing:validation.greaterThanToday"));
        }
        // MODIFICA
        else {
            const diff = dayjs(reservationFrom).diff(dayjs(val.value), "seconds");

            // reservationFrom modificata
            if (diff !== 0) {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(new Date(), t("pricing:validation.greaterThanToday"));
            }
            // reservationFrom NON modificata -> no min date
            else {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"));
            }
        }
    });

export const yupReservationToFunc = ({
                                         t,
                                         id,
                                         reservationTo,
                                         reservationFromFieldName
                                     }: { t: Function, id: number | null, reservationTo: string, reservationFromFieldName: string }) => yup
    .date()
    .nullable()
    .required(t("translation:validation.fieldMandatory"))
    .typeError(t("pricing:validation.date"))
    // @ts-ignore
    .when(["id", reservationFromFieldName], (yupId, yupReservationFrom, schema, val) => {
        const reservationFromFormatted = dayjs(yupReservationFrom).format("L LT");
        // CREAZIONE
        if (id === null) {
            // reservationFrom non ancora settata -> reservationTo maggiore di adesso
            if (!(schema.isValidSync(yupReservationFrom))) {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"));
                // .min(new Date(), t("pricing:validation.greaterThanToday"));
            }
            // reservationFrom settata -> reservationTo maggiore di reservationFrom e adesso
            else {
                const reservationFromDiffNow = dayjs(yupReservationFrom).diff(dayjs());
                // reservationFromDiffNow < 0 => reservationFrom è nel passato
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(
                        //reservationFromDiffNow < 0 ? new Date() :
                        yup.ref(reservationFromFieldName),
                        `${
                            //reservationFromDiffNow < 0 ? t("pricing:validation.greaterThanToday") : 
                            t("pricing:validation.greaterThan")
                        } ${
                            //reservationFromDiffNow < 0 ? "" : 
                            reservationFromFormatted
                        }`);
            }
        }
        // MODIFICA
        else {
            const diff = dayjs(reservationTo).diff(dayjs(val.value), "seconds");
            const reservationFromDiffNow = dayjs(yupReservationFrom).diff(dayjs(), "seconds");

            // reservationTo modificata
            // OR
            // reservationTo NON modficata ma reservationFrom modificata
            // -> reservationTo maggiore di reservationFrom e di adesso
            if (diff !== 0 || (diff === 0 && reservationFromDiffNow > 0)) {
                // reservationFrom nel futuro -> reservationTo maggiore di reservationFrom
                if (reservationFromDiffNow > 0) {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(yup.ref(reservationFromFieldName), `${t("pricing:validation.greaterThan")} ${reservationFromFormatted}`);
                }
                // reservationFrom nel passato -> reservationTo maggiore dell'adesso
                else {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(new Date(), t("pricing:validation.greaterThanToday"));
                }
            }
            // reservationTo NON modificata -> no min date
            else {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(new Date(), t("pricing:validation.greaterThanToday"));
            }
        }
    });

export const yupPickupFromFunc = ({
                                      t,
                                      id,
                                      pickupFrom
                                  }: { t: Function, id: number | null, pickupFrom: string, }) => yup
    .date()
    .nullable()
    .required(t("translation:validation.fieldMandatory"))
    .typeError(t("pricing:validation.date"))
    // @ts-ignore
    .when(["id", "reservationFrom"], (yupId, yupReservationFrom, schema, val) => {
        const reservationFromFormatted = dayjs(yupReservationFrom).format("L LT");
        // CREAZIONE
        if (id === null) {
            // reservationFrom non ancora settata -> pickupFrom maggiore di adesso
            if (!(schema.isValidSync(yupReservationFrom))) {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"));
                // .min(new Date(), t("pricing:validation.greaterThanToday"));
            }
            // reservationFrom settata -> pickupFrom maggiore di reservationFrom (rimosso controllo sull'adesso)
            else {
                // const reservationFromDiffNow = dayjs(yupReservationFrom).diff(dayjs());
                // rimosso controllo: reservationFromDiffNow < 0 -> reservationFrom è nel passato, quindi pickupFrom deve essere maggiore di adesso
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(
                        // reservationFromDiffNow < 0 ? new Date() :
                        yup.ref("reservationFrom"),
                        `${
                            // reservationFromDiffNow < 0 ? t("pricing:validation.greaterThanToday") :
                            t("pricing:validation.greaterThan")} ${
                            // reservationFromDiffNow < 0 ? "" :
                            reservationFromFormatted
                        }`);
            }
        }
        // MODIFICA
        else {
            const diff = dayjs(pickupFrom).diff(dayjs(val.value), "seconds");
            const reservationFromDiffNow = dayjs(yupReservationFrom).diff(dayjs(), "seconds");
            const reservationFromPickupFrom = dayjs(yupReservationFrom).diff(dayjs(val.value), "seconds");
            // pickupFrom modificata
            // OR
            // pickupFrom NON modificata ma reservationFrom modificata
            // -> pickupFrom maggiore di reservationFrom e di adesso
            if (diff !== 0) {
                // reservationFrom nel futuro -> pickupFrom maggiore di reservationFrom
                if (reservationFromDiffNow > 0) {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(yup.ref("reservationFrom"), `${t("pricing:validation.greaterThan")} ${reservationFromFormatted}`);
                }
                // reservationFrom nel passato -> pickupFrom maggiore dell'adesso
                else {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(new Date(), t("pricing:validation.greaterThanToday"));
                }
            }
            // pickupFrom NON modificata
            else {
                // pickup NON MODIFICATA ma inferiore a reservation from
                if (reservationFromPickupFrom > 0) {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(yup.ref("reservationFrom"), `${t("pricing:validation.greaterThan")} ${reservationFromFormatted}`);
                } else {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"));
                }
            }
        }
    });

export const yupPickupToFunc = ({
                                    t,
                                    id,
                                    reservationTo,
                                    pickupFrom,
                                    pickupTo,
                                    pickupFromFieldName
                                }: { t: Function, id: number | null, reservationTo: string, pickupFrom: string, pickupTo: string, pickupFromFieldName: string }) => yup
    .date()
    .nullable()
    .required(t("translation:validation.fieldMandatory"))
    .typeError(t("pricing:validation.date"))
    // @ts-ignore
    .when(["id", pickupFromFieldName, "reservationTo"], (yupId, yupPickupFrom, yupReservationTo, schema, val) => {
        const pickupFromFormatted = dayjs(yupPickupFrom).format("L LT");
        const reservationToFormatted = dayjs(yupReservationTo).format("L LT");

        // CREAZIONE
        if (id === null) {
            // pickupFrom settata e reservationTo NON settata -> pickupTo maggiore di pickupFrom
            if (yupPickupFrom && !yupReservationTo) {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(yup.ref("pickupFrom"), `${t("pricing:validation.greaterThan")} ${pickupFromFormatted}`);
            }
            // pickupFrom NON settata e reservationTo settata -> pickupTo maggiore di reservationTo
            else if (!yupPickupFrom && yupReservationTo) {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(yup.ref("reservationTo"), `${t("pricing:validation.greaterThan")} ${reservationToFormatted}`);
            }
            // pickupFrom settata e reservationTo settata -> pickupTo maggiore della più grande tra pickupFrom e reservationTo
            else if (yupPickupFrom && yupReservationTo) {
                const pickupFromDiffReservationTo = dayjs(yupPickupFrom).diff(dayjs(yupReservationTo), "seconds");
                // const pickupFromOrReservationToDiffNow = pickupFromDiffReservationTo > 0 ? dayjs(yupPickupFrom).diff(dayjs()) : dayjs(yupReservationTo).diff(dayjs());

                // se pickupFromDiffReservationTo > 0 && pickupFromOrReservationToDiffNow > 0 => pickupFrom è nel futuro
                // se pickupFromDiffReservationTo < 0 && pickupFromOrReservationToDiffNow > 0 => reservationTo è nel futuro
                // rimosso controllo: pickupFromOrReservationToDiffNow < 0 => pickupFrom o reservationTo sono nel passato, quindi pickupTo deve essere maggiore di adesso
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(
                        // pickupFromOrReservationToDiffNow < 0 ?
                        //     new Date() :
                        pickupFromDiffReservationTo > 0 ?
                            yup.ref("pickupFrom") :
                            yup.ref("reservationTo"),
                        `${
                            // pickupFromOrReservationToDiffNow < 0 ? t("pricing:validation.greaterThanToday") : 
                            t("pricing:validation.greaterThan")} ${
                            // pickupFromOrReservationToDiffNow < 0 ? "" :
                            pickupFromDiffReservationTo > 0 ? pickupFromFormatted : reservationToFormatted}`);
            }
            // pickupFrom NON settata e reservationTo NON settata -> pickupTo maggiore dell'adesso
            else {
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"));
                // .min(new Date(), t("pricing:validation.greaterThanToday"));
            }
        }
        // MODIFICA
        else {
            // @ts-ignore
            const diff = dayjs(pickupTo).diff(dayjs(val.value), "seconds");
            const pickupFromDiffNow = dayjs(pickupFrom).diff(dayjs(), "seconds");
            const reservationToDiffNow = dayjs(reservationTo).diff(dayjs(), "seconds");

            // pickupTo modificata
            // OR
            // pickupTo NON modificata ma reservationTo o pickupFrom modificati
            // -> pickupTo maggiore della più grande tra pickupFrom e reservationTo e l'adesso
            if (diff !== 0 || (diff === 0 && (pickupFromDiffNow > 0 || reservationToDiffNow > 0))) {
                // pickupFrom settata e reservationTo NON settata -> pickupTo maggiore di pickupFrom
                if (yupPickupFrom && !yupReservationTo) {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(yup.ref("pickupFrom"), `${t("pricing:validation.greaterThan")} ${pickupFromFormatted}`);
                }
                // pickupFrom NON settata e reservationTo settata -> pickupTo maggiore di reservationTo
                else if (!yupPickupFrom && yupReservationTo) {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(yup.ref("reservationTo"), `${t("pricing:validation.greaterThan")} ${reservationToFormatted}`);
                }
                // pickupFrom settata e reservationTo settata -> pickupTo maggiore della più grande tra pickupFrom e reservationTo e adesso
                else if (yupPickupFrom && yupReservationTo) {
                    const pickupFromDiffReservationTo = dayjs(yupPickupFrom).diff(dayjs(yupReservationTo), "seconds");
                    const pickupFromOrReservationToDiffNow = pickupFromDiffReservationTo > 0 ? dayjs(yupPickupFrom).diff(dayjs(), "seconds") : dayjs(yupReservationTo).diff(dayjs(), "seconds");

                    // se pickupFromDiffReservationTo > 0 && pickupFromOrReservationToDiffNow > 0 => pickupFrom è nel futuro
                    // se pickupFromDiffReservationTo < 0 && pickupFromOrReservationToDiffNow > 0 => reservationTo è nel futuro
                    // pickupFromOrReservationToDiffNow < 0 => pickupFrom o reservationTo sono nel passato
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(pickupFromOrReservationToDiffNow < 0 ?
                                new Date() :
                                pickupFromDiffReservationTo > 0 ?
                                    yup.ref("pickupFrom") :
                                    yup.ref("reservationTo"),
                            `${pickupFromOrReservationToDiffNow < 0 ? t("pricing:validation.greaterThanToday") : t("pricing:validation.greaterThan")} ${pickupFromOrReservationToDiffNow < 0 ? "" : pickupFromDiffReservationTo > 0 ? pickupFromFormatted : reservationToFormatted}`);
                }
                // pickupFrom NON settata e reservationTo NON settata -> pickupTo maggiore dell'adesso
                else {
                    return yup
                        .date()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                        .typeError(t("pricing:validation.date"))
                        .min(new Date(), t("pricing:validation.greaterThanToday"));
                }
            }
            // pickupTo NON modificata -> no min date
            else {
                const pickupFromDiffReservationTo = dayjs(yupPickupFrom).diff(dayjs(yupReservationTo), "seconds");
                // const pickupFromOrReservationToDiffNow = pickupFromDiffReservationTo > 0 ? dayjs(yupPickupFrom).diff(dayjs(), "seconds") : dayjs(yupReservationTo).diff(dayjs(), "seconds");
                return yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory"))
                    .typeError(t("pricing:validation.date"))
                    .min(
                        // pickupFromOrReservationToDiffNow < 0 ?
                        //     new Date() :
                        pickupFromDiffReservationTo > 0 ?
                            yup.ref("pickupFrom") :
                            yup.ref("reservationTo"),
                        `${
                            // pickupFromOrReservationToDiffNow < 0 ? t("pricing:validation.greaterThanToday") : 
                            t("pricing:validation.greaterThan")} 
                                    ${pickupFromDiffReservationTo > 0 ? pickupFromFormatted : reservationToFormatted}`);
            }
        }
    });
/* VALIDAZIONI DATE YUP - END */